/**
 * メッセージペイロード由来のURLを安全に扱うためのヘルパー。
 *
 * チャットのメッセージは PubNub 経由で受け取るため、URL の中身をサーバーが保証しない。
 * `javascript:` や `data:` のスキームをそのまま window.open / href に渡すと、
 * 管理画面のオリジンでスクリプトが実行され得るため、http(s) のみを通す。
 */
export const toSafeHttpUrl = (raw?: string | null): string | undefined => {
  if (!raw) return undefined;
  try {
    const url = new URL(raw, window.location.origin);
    return url.protocol === 'http:' || url.protocol === 'https:'
      ? url.href
      : undefined;
  } catch {
    return undefined;
  }
};
